module.exports = __webpack_public_path__ + "img/header-parallax-1.bf186d29.jpg";